export default __webpack_public_path__ + "static/media/cross.82813f20.svg";